




















import {
  defineComponent,
  computed
} from '@vue/composition-api'
import { TcButton } from '@telia/shared-ui-components'

export default defineComponent({
  props: {
    title: String,
    price: String,
    offsetTop: {
      type: Number,
      default: 0
    },
    bindTime: Number
  },
  components: {
    TcButton
  },
  setup (props) {
    const dynamicPriceStyle = computed(() => ({ 'margin-top': props.offsetTop + 'px' }))

    return {
      dynamicPriceStyle
    }
  }
})
